import { CircularProgress, Grid } from "@mui/material"

export const Loading = () => {
    return (
        <Grid
            width={"100vw"}
            height={"100vh"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
        >
            <CircularProgress/>
        </Grid>
    )
}